// seller-service property endpoint paths (relative to VITE_SELLER_API_URL). The
// service mounts under the `/api` global prefix. Referenced via this constant so
// a path change is a single edit — never hard-coded at call sites.
export const propertyEndpointPaths = {
  PROPERTIES: '/api/properties',
  PORTFOLIO_STATUS: '/api/properties/portfolio-status',
  STATUS_COUNTS: '/api/properties/status-counts',
  property: (id: string) => `/api/properties/${id}`,
  propertySettlement: (id: string) => `/api/properties/${id}/settlement`,
  propertyExtension: (id: string) => `/api/properties/${id}/extension`,
} as const
